/** * Page : HomeView * * This is the first page when the user click on "La
Haute maison". It's home presentation * */

<template>
  <div class="home-view">
    <header>
      <div class="home-img_container">
        <img
          :src="
            isMobile
              ? body.images.mobilelandscapeHomeSrc
              : body.images.landscapeHomeSrc
          "
          :alt="body.images.landscapeHomeAlt"
          class="home-img_banniere"
        />

        <!-- Overlay noir -->
        <div class="home-img_overlay"></div>
        <div class="home-img_text">
          <h1>{{ $t("home.bannerTitle") }}</h1>

          
           <button @click="handleClick(body.links.availabilityUrl)" class="btn_available_price">
              {{ $t("home.available_price") }}
            </button>
  
        </div>

        <!-- scrow arrow to encourage the reader to scroll down -->
        <div class="home-img_scroll">
          <span class="scroll-arrow">&#8595;</span>
        </div>
      </div>
    </header>

    <!-- Summary of the main elements of the house -->
    <main>
      <div class="welcome_container">
        <div class="welcome_text">
          <MainTitle
            :anchor="$t('home.firstText')"
            :title="$t('home.title')"
            :keyword="$t('home.keyword')"
            :subtitle="$t('home.subtitle')"
          >
          </MainTitle>

          <!-- Filters the elements to avoid overloarding visuals -->
          <div
            class="welcome_btn"
            data-aos="fade-up"
            data-aos-duration="900"
            data-aos-delay="150"
data-aos-easing="ease-out"
          >
            <button
              @click="setActiveTab('Outside')"
              :class="{ active: activeTab === 'Outside' }"
            >
              {{ $t("home.outside") }}
            </button>
            <button @click="handleClick(body.links.roomsUrl)">
              {{ $t("home.rooms") }}
            </button>
            <button @click="handleClick(body.links.livingSpaceUrl)">
              {{ $t("home.livingSpaces") }}
            </button>
          </div>

          <!-- Dynamic content: Displays information about the outside area when the tab is activ  -->
          <div v-show="activeTab === 'Outside'" class="info-content"
            
            data-aos="fade-up"
            data-aos-duration="900"
            data-aos-delay="150"
data-aos-easing="ease-out">
            <ResumeCard
              :alt="body.images.outsideAlt"
              :src="body.images.outsideSrc"
              :items="[
                $t('home.outsideItem1'),
                $t('home.outsideItem2'),
                $t('home.outsideItem3'),
              ]"
            >
            </ResumeCard>
          </div>
        </div>
      </div>
      <!-- Button to encourage users to book -->
      <div class="dispo_btn">
        <PageLink
          :url="body.links.availabilityUrl"
          :text="$t('home.available_price')"
          background="blue"
        />
      </div>

      <!-- Invite users to visit the activity page -->
      <div
        class="landscape_container"
        data-aos="fade-up"
        data-aos-duration="1500"
        data-aos-once="true"
      >
        <img
          :src="body.images.landscapeSrc"
          :alt="body.images.landscapeAlt"
          class="landscape_img"
        />
        <div class="landscape_text_overlay">
          <MainTitle
            :title="$t('home.landscapeTitle')"
            :subtitle="$t('home.landscapeSubTitle')"
          />
          <PageLink
            :url="body.links.discoverUrl"
            :text="$t('home.moreInformations')"
          />
        </div>
      </div>

      <!-- Informs the user of the house's location -->
      <div class="map_container"
      data-aos="fade-right"
data-aos-duration="900"
data-aos-once="true"
data-aos-easing="ease-out">

        <div class="map_text">
          <MainTitle
            :title="$t('home.praticialTitle')"
            :subtitle="$t('home.praticalText')"
            background="title_blue"
          >
          </MainTitle>
          <div
            data-aos="fade"
            data-aos-duration="1000"
            data-aos-easing="ease-in-out"
          >
            <p>
              <strong>{{ $t("home.praticalTextCar") }} </strong> <br />
              {{ $t("home.praticalTextCarDesc") }}
            </p>
            <p>
              <strong> {{ $t("home.praticalTextTrain") }}</strong> <br />
              {{ $t("home.praticalTextTrainDesc") }}
            </p>
          
          </div>
        </div>
        <div
          id="map"
          data-aos="fade"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          data-aos-once="true"
       
        >
         <OpinionReview :reviews="avisClients" /></div>
      </div>
      
    </main>
  </div>
</template>

<script>
import MainTitle from "../components/MainTitle.vue";
import ResumeCard from "../components/ResumeCard.vue";
import PageLink from "../components/PageLink.vue";
import OpinionReview from "../components/OpinionReview.vue";
import L from "leaflet";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import "leaflet/dist/leaflet.css";
import { useHead } from "@vueuse/head";
import fr from "@/locales/fr.json";
import en from "@/locales/en.json";
import de from "@/locales/en.json"



export default {
    name: "HomeView",

  // import
  components: {
    PageLink,
    MainTitle,
    ResumeCard,
    OpinionReview,
  },
    setup() {
      const { locale } = useI18n();

    // Avis clients bilingues
   const avisClients = computed(() => {
    switch (locale.value) {
      case "fr":
        return fr.reviews.avisClients;
      case "de":
        return de.reviews.avisClients;
      default:
        return en.reviews.avisClients;
    }
  });

    // Définir le head de la page
    useHead({
      title: "La Haute Maison",
      meta: [
        {
          name: "description",
          content:
            "Maison tout confort en location à Merrien, proche de la mer et des sentiers de randonnée. Idéale pour familles ou randonneurs sur le GR34.",
        },
      ],
    });
    return { avisClients}
  },
  
  data() {
    return {
      isMobile: false,
      // By default displays rooms informations
      activeTab: "Outside",

      body: {
        images: {
          landscapeHomeSrc: require("../assets/images/landscape/sea.jpg"),
          landscapeHomeAlt: "Maison à louer à Merrien, Moëlan-sur-Mer",
          mobilelandscapeHomeSrc: require("../assets/images/landscape/sea_mobile.jpg"),
          outsideSrc: require("../assets/images/haute-maison.jpg"),
          outsideAlt: "Bretagne Sud",
          landscapeSrc: require("../assets/images/landscape.jpg"),
          landscapeAlt: "GR34 et plages",
        },

        links: {
          roomsUrl: "/chambres",
          livingSpaceUrl: "/espaces-a-vivre",
          availabilityUrl:"/reservations",
          moreInformations: "En savoir +",
          discoverUrl: "https://www.youtube.com/watch?v=drBGo4fOUhY&t=264s",
        },
      },
    };
  },
  methods: {
    //change parameter "ActivTab" depending on which button is clicked
    setActiveTab(tab) {
      this.activeTab = tab;
    },
    handleClick(url) {
      console.log("router:", this.$router);
      if (this.$router) {
        this.$router.push(url);
      } else {
        console.warn("Router non disponible");
      }
    },

    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },
  },
  mounted() {
    // map initialise
    const map = L.map("map").setView([47.78158, -3.64361], 9);

    // display map
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    }).addTo(map);

    const customIcon = L.icon({
      iconUrl: require("../assets/icons/epingle.png"),
      iconSize: [32, 32],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32],
    });

    const marker = L.marker([47.78158, -3.64361], { icon: customIcon }).addTo(
      map
    );

    // When icon is clicked, display a popup with name of the house
    marker.bindPopup("La Haute Maison").openPopup();

    //if mobile change landscape home
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkMobile);
  },
};
</script>

<style lang="scss">
@import "../assets/styles/_variables.scss";


.home-view {
  margin: 0 auto;
}
.btn_available_price{
  background-color: transparent;
  color: white;
  border-width: 1.2px;
border-color: rgb(236, 236, 243); 
 border-style:dotted;
}

.home-img_banniere {
  width: 100%;
  object-fit: cover;
  display: block;
}
.home-img_container {
  position: relative;
  width: 100%;
}

.home-img_overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1); /* ajuste ici la transparence */
  z-index: 1;
}

/* Position the arrow at the bottom of the video */
.home-img_scroll {
  position: absolute;
  bottom: 3vh;
  left: 50%;
  transform: translateX(-50%);
  font-size: 3rem;
  color: white;
  animation: bounce 1.5s infinite;
  cursor: pointer;
  text-align: center;
}

/* Arrow animation to encourage scrolling */
@keyframes bounce {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(10px);
  }
  100% {
    transform: translateY(0);
  }
}

.home-img_text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  text-align: center;
  z-index: 2;
  text-shadow: 1px 1px 6px rgba(0, 0, 0, 0.6);
}

.welcome_container {
  margin-top: $spacing-extralarge;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  text-align: left;
}

.welcome_text {
  width: 75%;
}

.welcome_btn {
  display: flex;
  flex-wrap: wrap;
  gap: $spacing-min;

  button {
    background: #fff;
  }
}

.info-content {
  margin-top: $spacing-large;
  display: flex;
  justify-content: center;
  gap: $spacing-base;
}
.dispo_btn {
  margin-top: $spacing-extralarge;
  text-align: center;
}

.landscape_container {
  margin-top: $spacing-extralarge;
  display: grid;
  width: 100%;
  max-height: 60vh;
  background-color: #f3f3f3;
  overflow: hidden;
  position: relative;
}
.landscape_img {
  width: 100%;
  max-height: 50vh;
  object-fit: cover;
  grid-area: 1 / 1; /* Places image in first grid layer */
}

.landscape_text_overlay {
  grid-area: 1 / 1; /* Superimpose text on image */
  justify-self: end;
  text-align: left;
  color: white;
  align-self: center;
  width: 40%;
  z-index: 2;
  padding: 1em;
  background-color: rgba(160, 219, 241, 0.49);
  border-radius: 0.3125rem;
}

.map_container {
  margin-top: $spacing-large;
  display: flex;
  flex-wrap: wrap; /* passer à la ligne suivante quand il n'y a plus de place */
  justify-content: space-around;
  align-items: center;
  gap: $spacing-base;
}

#map {
  margin-top: $spacing-base;
  height: 55vh;
  width: 50%;
  border: 0.0625rem solid #ccc;
  border-radius: 0.5rem;
}

.map_text {
  max-width: 37.5rem;
}

@media (max-width: 48rem) {
  // 768px
  .welcome_container,
  .info-content,
  .map_container {
    flex-direction: column;
    align-items: center;
  }

  .welcome_text,
  .map_text,
  .landscape_text_overlay {
    width: 90%;
  }

  .info-content {
    gap: 0;
  }

  .welcome_btn button {
    flex: 1;
  }

  #map {
    height: 30vh;
    width: 100%;
  }
}

@media (max-width: 30rem) {
  // 480px
  .welcome_btn button {
    font-size: $font-size-small;
    padding: 0.375rem 0.75rem;
  }
}
</style>
